<template>
    <el-drawer
        title="视频播放"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="ltr"
        class="video_drawer"
        size="100%"
        :append-to-body="true"
        :before-close="close">
        <div class="panel fx fx-center fx-g1"  >
            <div id="myVideo"></div>
        </div>
        <span class="fx fx-center padding10">
            <el-button type="primary" @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>
    .panel {
        background: transparent;
    }
    #myVideo {
        width: 80%;
        height: 80%;
    }
    .video {
        min-width: 600px;
        min-height: 400px;
        max-width: 1200px;
        max-height: 800px;
    }

</style>
<!--<script href="https://cdn.bootcss.com/video.js/7.6.5/alt/video-js-cdn.min.css" rel="stylesheet"></script>-->
<!--<script src="https://cdn.bootcss.com/video.js/6.6.2/video.js"></script>-->
<!--<script src="https://cdn.bootcss.com/videojs-contrib-hls/5.15.0/videojs-contrib-hls.min.js"></script>-->
<!--<script>-->
<!--  // videojs 简单使用-->
<!--  var myVideo = videojs('myVideo',{-->
<!--      bigPlayButton : true,-->
<!--      textTrackDisplay : false,-->
<!--      posterImage: false,-->
<!--      errorDisplay : false,-->
<!--  })-->
<!--  myVideo.play() // 视频播放-->
<!--  myVideo.pause() // 视频暂停-->
<!--</script>-->
<script>


    export default {
        props: [
            "url",
        ],
        data() {
            return {
                show: false,
                player: null,
                options : {
                    controls: true, // 是否显示底部控制栏
                    preload: "auto", // 加载<video>标签后是否加载视频
                    playbackRates: [0.5, 1, 1.5, 2],// 倍速播放
                    language: "zh-CN",
                    controlBar: {
                        // 自定义按钮的位置
                        children: [
                            {
                                name: "playToggle"
                            },
                            {
                                name: "progressControl"
                            },
                            {
                                name: "currentTimeDisplay"
                            },
                            {
                                name: "timeDivider"
                            },
                            {
                                name: "durationDisplay"
                            },

                            {
                                name: "volumePanel", // 音量调整方式横线条变为竖线条
                                inline: false
                            },
                            {
                                name: "fullscreenToggle"
                            }
                        ]
                    }
                }
            }

        },


        methods: {
            close() {
                this.player.remove();
                this.$emit("close");
            },
        },
        mounted() {
            this.show = true;
            this.$nextTick(function () {
                // eslint-disable-next-line no-undef
                this.player = new ckplayer({
                    container: "#myVideo",
                    video: this.url,
                    plug: this.url.endsWith("m3u8") ? 'hls.js' :'',
                });
            })
            // if(this.url.indexOf('m3u8') != -1){
            //      this.$nextTick(function () {
            //         this.player = this.$video(this.$refs.myVideo, this.options);
            //     })
            // }else{
            //     this.$nextTick(function () {
            //         this.player = this.$video(this.$refs.myvideo, this.options);
            //     })
            // }

        },


    }
</script>
